interface ValueBounds {
    min?: number;
    max?: number;
}

export const MIN_STEP = 1;

// There are alternate solutions to ensuring no "non-numeric"
// characters are accepted as `value`. We could be more clever
// and strip out any unsupported characters, and combine the
// remaining supported characters, while also only allowing
// one leading `-` and one `.`. But until those concerns are
// needed, we will keep this solution ultra-simple.

export function numberFromString(value = '') {
    // Restricting to an `integer` means we will immediately
    // round the value once the user enters `.`
    const parsed = parseInt(value, 10);
    return isNaN(parsed) ? 1 : parsed;
}

export function maxWithinBounds({ min, max }: ValueBounds) {
    if (min === undefined) return undefined;
    return max !== undefined && max <= min ? min + 1 : max;
}

export function valueWithinBounds(value: number, { min, max }: ValueBounds) {
    const withinMinBound = Math.max(value, min ?? value);
    return Math.min(withinMinBound, max ?? withinMinBound);
}
